export default function useOrigin(url) {
  const urlObj = new URL(url);
  return urlObj.origin;
}
